import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import {
  Typography,
  Divider,
  Button,
  TextField,
  Grid,
  FormGroup,
  FormControlLabel,
  Switch
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { hideSnackbar, showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
//
import { styled } from "@mui/material/styles";

import CustomSwitch from "SharedComponents/CustomSwitch";

//

import driverApi from "../../../../../Services/Driver";

const Status = ({ onRef, driverId , setsubmitButton , setSkipButton  }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  setsubmitButton(true);
  setSkipButton(true);
  const [row, setRow] = useState([]);
  const [isEditable, setIsEditable] = useState(false);
  const [driverStatus, setDriverStatus] = useState();
  const [accountStatus, setAccountStatus] = useState();
  const [driverServiceData, setDriverServiceData] = useState([]);

  const DriverServiceDetails = () => {
    dispatch(showLoader("Loading please wait..."));

    let validation = true;

    if (driverId === "" || driverId === undefined) {
      validation = false;
      dispatch(hideLoader());
    }

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setDriverServiceData(res?.data?.data);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    if (validation) {
      //console.log('driverId-->',driverId);
      driverApi.getDriverServiceDetails(driverId).then(onSuccess, onFailure);
    }
  };

  useEffect(() => {
    setDriverServiceData([]);
    DriverServiceDetails();
  }, []);
  
  useEffect(() => {
    if (driverServiceData && Object.keys(driverServiceData).length > 0) {
      setAccountStatus(
        driverServiceData?.accountStatus === "APPROVED" ? "APPROVED" 
      : driverServiceData?.accountStatus === "BANNED" ? "BANNED" : "ONBOARDING"
      );
      setDriverStatus(
        driverServiceData?.driverAccountStatus === "ACTIVE" ? true : false
      );
    }
  }, [driverServiceData]);

  const handleUpdateStates = () => {
    setDriverStatus((prev) => !prev);
  };

  const handleAccountStatus = (event) => {
    setAccountStatus(event.target.value);
  };

  const updateDriverService = () => {

    if (driverId === "" || driverId === undefined) return; 

    let data = {
      accountStatus: accountStatus,
      driverAccountStatus: accountStatus === "BANNED" ?  "DE_ACTIVE" : driverStatus ? "ACTIVE" : "DE_ACTIVE",
    };
    //console.log('data--->',data);
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Driver status updated successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Error while update the driver status",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

      driverApi
        .updateDriverServiceStatus(driverId, { ...data })
        .then(onSuccess, onFailure);
  };

  useEffect(() => {
    if (driverStatus !== undefined || accountStatus !== undefined) {
      updateDriverService();
    }
  }, [driverStatus, accountStatus]);
 
  const getFormData = () => {
    return { driverStatus, accountStatus };
  };

  useEffect(() => {
    onRef && onRef(getFormData);
  }, [onRef, getFormData]);


  if (accountStatus === undefined || driverStatus === undefined) {
    return <Typography>Loading...</Typography>;
  }
  return (
    <>
       <FormControlLabel
      control={
        <Switch
          checked={isEditable}
          onChange={(e) => setIsEditable(e.target.checked)}
          color="primary"
        />
      }
      label="Enable Edit"
    />
   <Typography
  variant="subtitle1"
  sx={{
    color: '#888888',
    fontStyle: 'italic',
    mt: 2,
    mb: 2,
  }}
>
  " Note: Manually updating the driver status will reflect the corresponding changes in the app flow. "
</Typography>     

<div style={{ opacity: isEditable ? 1 : 0.6, pointerEvents: isEditable ? 'auto' : 'none' }}>
      <Grid container>
        <Grid item xs={12} className={classes.switchWrapper}>
          <Typography variant="body1">Account Status</Typography>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={accountStatus}
              onChange={handleAccountStatus}
              disabled={!isEditable}
            >
              <FormControlLabel
                value="ONBOARDING"
                control={<Radio />}
                label="On Boarding"
              />
              <FormControlLabel
                value="APPROVED"
                control={<Radio />}
                label="Approve"
              />
              <FormControlLabel
                value="BANNED"
                control={<Radio />}
                label="Banned"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12} className={classes.divider}>
          <Divider />
        </Grid>
        <Grid item xs={12} className={classes.switchWrapper}>
          <Typography variant="body1">
            Driver Status (Active/De-active)
          </Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <CustomSwitch
                  checked={driverStatus}
                  onChange={() => handleUpdateStates()}
                />
              }
            />
          </FormGroup>
        </Grid>
        <Grid item xs={12} className={classes.divider}>
          <Divider />
        </Grid>
        <Grid item xs={12} className={classes.container}>
          <Grid item xs={12} className={classes.btn}></Grid>
        </Grid>
      </Grid>
            </div>
    </>
  );
};

export default Status;
